import { Card, CardContent } from '@mui/material'
import React, { useRef, useState } from 'react'
import GroupPic from '@/assets/img/realtime/group.webp'

import { GroupTelecommand } from './group-telecommand.component'

const GroupItem = ({ item }) => {
    const [showTelecommand, setShowTelecommand] = useState(false)
    const ref = useRef()

    return (
        <>
            <Card
                key={`card_${item.name}`}
                ref={ref}
                style={{
                    cursor: 'pointer',
                    height: 100,
                    position: 'relative',
                    width: '100%',
                }}
                className="card-hover"
                onClick={() => {
                    setShowTelecommand(true)
                }}
            >
                <img
                    src={GroupPic}
                    style={{
                        height: '100%',
                        width: '100%',
                        objectFit: 'cover',
                        position: 'absolute',
                    }}
                />

                <CardContent
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        zIndex: 10,
                        position: 'relative',
                        fontWeight: 'bold',
                        height: '100%',
                    }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            left: 10,
                            bottom: 0,
                            color: 'white',
                        }}
                    >
                        {item?.name?.toUpperCase()}
                    </div>
                </CardContent>
            </Card>
            {showTelecommand && (
                <GroupTelecommand open={showTelecommand} onClose={() => setShowTelecommand(false)} item={item} />
            )}
        </>
    )
}

export default GroupItem
